/* eslint camelcase: "off" */
import {
  userClickVideo,
  userViewVideo,
  userViewVideoHeartBeat,
  userViewVideoEnd,
  userRealPlayVideo, // 真实播放的有效时间
  userBehavior,
} from 'amkit3-modules/utils/tafOld/api'

import { isFullscreen } from 'amkit3-modules/utils/fullscreen'

import StatisticEvent from './statistic-event'

function getNetworkType() {
  const ua = navigator.userAgent
  let networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other'
  networkStr = networkStr.toLowerCase().replace('nettype/', '')
  let networkType
  switch (networkStr) {
    case 'wifi':
      networkType = 1
      break
    case '4g':
    case '3g':
    case '3gnet':
    case '2g':
      networkType = 2
      break
    default:
      networkType = -1
  }
  networkType = !navigator.onLine ? 0 : networkType
  return networkType
}

class TafStatistic {
  constructor(collector) {
    this.playTimes = {}
    this.playTimesKeyLength = Object.keys(this.playTimes).length
    // 设备id
    this.sdid = ''
    this.sVideoId = collector.getVid()
    this.lUid = collector.getYYUId()
    this.sViewId = ''
    this.iHeartbeatFre = 10
    this.timer = null
    this.mBehavior = {}
    this.startTime = Date.now()
    this.isEnded = false
    this.isFirstWatch = true
    this.isFirstRealWatch = true

    let pro = 'huyasp' + (process.env.NODE_ENV === 'development' || process.env.TEST ? '_test' : '')
    var pasDelegate = (func, dur) => {
      func(
        dur,
        pro,
        collector.getSessionId(),
        'live',
        collector.getMId(),
        collector.getYYUId(),
        collector.getPas(),
        'YY',
        1,
        1,
        collector.getVid(),
        window.location.href,
        0,
        window.location.href,
        document.referrer,
        'zh-cn',
        collector.getOS(),
        collector.getSre(),
        'web',
        new Date().valueOf(),
      )
    }

    let curTime = Date.now()
    let playTimeStatis = () => {
      // let nextTime = Date.now()
      // if (!this.isEnded && nextTime - curTime >= this.iHeartbeatFre * 1000) {
      //   curTime = nextTime
      //   userViewVideoHeartBeat({
      //     lUid: this.lUid,
      //     sVideoId: this.sVideoId,
      //     sdid: this.sdid,
      //     sViewId: this.sViewId,
      //     mExt: {
      //       network: getNetworkType(),
      //       screen: +isFullscreen(),
      //       volume: +(collector.getVolume() * 100).toFixed(2),
      //     },
      //     iState: collector.getPlayerState(),
      //     lCurPos: Math.floor(collector.getCurrentTime())
      //   }).then(res => {
      //     const { tRsp, sViewId = '' } = res
      //     if (sViewId) {
      //       this.sViewId = sViewId
      //     }
      //   })
      // }
      // requestAniFrame(playTimeStatis)
      if (!this.iHeartbeatFre || this.iHeartbeatFre < 5) {
        this.iHeartbeatFre = 10
      }
      setTimeout(() => {
        userViewVideoHeartBeat({
          lUid: this.lUid,
          sVideoId: this.sVideoId,
          sdid: this.sdid,
          sViewId: this.sViewId,
          mExt: {
            network: getNetworkType(),
            screen: +isFullscreen(),
            volume: +(collector.getVolume() * 100).toFixed(2),
          },
          iState: collector.getPlayerState(),
          lCurPos: Math.floor(collector.getCurrentTime()),
        }).then(res => {
          const { tRsp, sViewId = '' } = res
          if (sViewId) {
            this.sViewId = sViewId
          }
        })
        playTimeStatis()
      }, this.iHeartbeatFre * 1000)
    }
    window.initFingerprint && window.initFingerprint(5002)
    this.sdid = localStorage.getItem('adid') || 0
    // 用户点击视频（当做视频正在打开）
    userClickVideo({
      lUid: this.lUid,
      sVideoId: this.sVideoId,
      sdid: this.sdid,
    })

    collector.on(StatisticEvent.PLAYER_LOAD, () => {
      // playLoad(collector.getVid(), 'web', collector.getChannelId(), window.location.href, document.referrer, collector.getLaiyuanv3())
      // webduowanvideoload(collector.getVid(), collector.getVname(), collector.getChannelId(), '', window.location.href, document.referrer, new Date().valueOf(), collector.getLaiyuanv3())
    })

    collector.on(StatisticEvent.PLAYER_REPLAY, () => {
      this.isFirstWatch = true
      this.isFirstRealWatch = true
      this.startTime = Date.now()
    })

    // 用户观看（第一次开始播放的时候触发）
    collector.on(StatisticEvent.PLAYER_PLAY, () => {
      if (!this.isFirstWatch) return
      this.isFirstWatch = false
      userViewVideo({
        lUid: this.lUid,
        sVideoId: this.sVideoId,
        sdid: this.sdid,
      })
        .then(res => {
          const { tRsp, sViewId, iHeartbeatFre } = res
          if (tRsp.iRet === 0) {
            this.sViewId = sViewId
            this.iHeartbeatFre = iHeartbeatFre || 10
            // 统计心跳上报
            playTimeStatis()
          }
        })
        .catch(() => {
          playTimeStatis()
        })
    })
    collector.on(StatisticEvent.PLAYER_PLAYING, () => {
      this.startTime = Date.now()
      userBehavior({
        lUid: this.lUid,
        sVideoId: this.sVideoId,
        sdid: this.sdid,
        sViewId: this.sViewId,
        mBehavior: {
          1: Math.floor(collector.getCurrentTime()),
        },
      })
    })
    collector.on(StatisticEvent.PLAYER_PAUSE, () => {
      this.startTime = null
      userBehavior({
        lUid: this.lUid,
        sVideoId: this.sVideoId,
        sdid: this.sdid,
        sViewId: this.sViewId,
        mBehavior: {
          0: '',
        },
      })
    })
    collector.on(StatisticEvent.TIME_UPDATE, () => {
      this.isEnded = false
      let currentTime = Math.floor(collector.getCurrentTime())
      if (!isNaN(currentTime) && currentTime !== this.lastCurrentTime) {
        this.playTimes[String(currentTime)] = true
      }
      this.lastCurrentTime = currentTime
      if (!this.isFirstRealWatch) return
      this.endTime = Date.now()
      if (this.startTime && this.endTime - this.startTime > 5000) {
        userRealPlayVideo({
          lUid: this.lUid,
          sVideoId: this.sVideoId,
          sdid: this.sdid,
          sViewId: this.sViewId,
        })
        this.isFirstRealWatch = false
      }
    })
    collector.on(StatisticEvent.PLAYBACK_PROGRESS_ERROR, () => {
      // pasDelegate(pas.hysp_videoplay_errortimes, '')
      // pasDelegate(ya.hysp_videoplay_errortimes, '')
    })
    collector.on(StatisticEvent.PLAYER_SEEK_CHANGE, () => {
      userBehavior({
        lUid: this.lUid,
        sVideoId: this.sVideoId,
        sdid: this.sdid,
        sViewId: this.sViewId,
        mBehavior: {
          4: Math.floor(collector.getCurrentTime()),
        },
      })
    })

    collector.on(StatisticEvent.PLAYER_VOLUME_CHANGE, volume => {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        userBehavior({
          lUid: this.lUid,
          sVideoId: this.sVideoId,
          sdid: this.sdid,
          sViewId: this.sViewId,
          mBehavior: {
            2: collector.getVolume(),
          },
        })
      }, 800)
    })
    collector.on(StatisticEvent.PLAYBACK_LAGGING, () => {
      // pasDelegate(pas.hysp_videoplay_badtimes, '')
    })
    collector.on(StatisticEvent.PLAYER_ENDED, () => {
      this.isEnded = true
      userViewVideoEnd({
        lUid: this.lUid,
        sVideoId: this.sVideoId,
        sdid: this.sdid,
        sViewId: this.sViewId,
      })
    })

    // window.addEventListener('beforeunload', (e) => {
    //   e.preventDefault();
    //   this.isEnded = true;
    //   userViewVideoEnd({
    //     lUid: this.lUid,
    //     sVideoId: this.sVideoId,
    //     sdid: this.sdid,
    //     sViewId: this.sViewId,
    //   });
    // });

    // })
  }
}

export default TafStatistic
